import { render, staticRenderFns } from "./ArchiveList.vue?vue&type=template&id=f27da30a&scoped=true"
import script from "./ArchiveList.vue?vue&type=script&lang=js"
export * from "./ArchiveList.vue?vue&type=script&lang=js"
import style0 from "./ArchiveList.vue?vue&type=style&index=0&id=f27da30a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27da30a",
  null
  
)

export default component.exports